import { gql } from '@apollo/client';

export const GET_ACCOUNT_TMS_DRIVERS_BY_CARRIER_ID = gql`
    query GetAccountTmsDriversByCarrierId($carrierId: Long!, $status: Int, $routeType: Int) {
        getAccountTmsDriversByCarrierId(carrierId: $carrierId, status: $status, routeType: $routeType) {
            id
            accountId
            carrierId
            driverName
            phoneNumber
        }
    }
`;

export interface AccountTmsDriverByCarrierIdType {
    id: number;
    accountId: number;
    carrierId: number;
    driverName: string | null;
    phoneNumber: string | null;
}

export interface GetAccountTmsDriversByCarrierIdResponse {
    getAccountTmsDriversByCarrierId: AccountTmsDriverByCarrierIdType[];
}

